import React from 'react';
import { motion } from 'framer-motion';
import { Beer, Wine, Milk, Store, Package, ArrowRight } from 'lucide-react';
import { Button } from './Button';
const industries = [{
  icon: <Beer className="w-5 h-5" data-id="element-307" />,
  name: 'Brewing and Craft Beer',
  assets: 'Bottles, kegs, crates'
}, {
  icon: <Wine className="w-5 h-5" data-id="element-308" />,
  name: 'Wine and Spirits',
  assets: 'Bottles, cases, pallets'
}, {
  icon: <Milk className="w-5 h-5" data-id="element-309" />,
  name: 'Dairy and Beverages',
  assets: 'Bottles, crates, totes'
}, {
  icon: <Store className="w-5 h-5" data-id="element-310" />,
  name: 'Grocery and Retail',
  assets: 'Pallets, display units'
}, {
  icon: <Package className="w-5 h-5" data-id="element-311" />,
  name: 'Logistics and E-commerce',
  assets: 'Pallets, returnable containers'
}];
export const Industries: React.FC = () => {
  return <section className="py-24 md:py-32 bg-surface border-t border-primary/5" data-id="element-312">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-313">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-2xl mb-14" data-id="element-314">
          <h2 className="font-display text-4xl md:text-5xl text-primary mb-6 leading-[1.05]" data-id="element-315">
            Built for every kind of supply chain.
          </h2>
          <p className="text-lg text-ink/70 leading-relaxed" data-id="element-316">
            If your business sends out something that can come back and be used
            again, we can probably handle it. Here are a few we work with today.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4" data-id="element-317">
          {industries.map((industry, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="group p-5 md:p-6 rounded-xl bg-white border border-primary/10 hover:border-leaf/40 hover:shadow-glossy transition-all duration-300 hover:-translate-y-0.5" data-id="element-318">
              <div className="w-10 h-10 rounded-lg bg-mint flex items-center justify-center text-leaf mb-4 group-hover:bg-leaf group-hover:text-white transition-colors duration-300" data-id="element-319">
                {industry.icon}
              </div>
              <h3 className="font-display text-lg text-primary mb-2 leading-tight" data-id="element-320">
                {industry.name}
              </h3>
              <p className="font-mono text-[10px] text-muted uppercase tracking-wider leading-relaxed" data-id="element-321">
                {industry.assets}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-14 flex flex-col sm:flex-row items-center justify-between gap-6 p-6 md:p-8 rounded-2xl bg-cream border border-primary/5" data-id="element-322">
          <div data-id="element-323">
            <h4 className="font-display text-xl text-primary mb-1" data-id="element-324">
              Don't see your industry?
            </h4>
            <p className="text-sm text-ink/70" data-id="element-325">
              If your supply chain moves a returnable asset, chances are we can
              serve it. Let's talk.
            </p>
          </div>
          <Button variant="primary" size="md" className="shrink-0" data-id="element-326">
            Talk to our team <ArrowRight className="ml-2 w-4 h-4" data-id="element-327" />
          </Button>
        </motion.div>
      </div>
    </section>;
};